import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';

@Injectable({
  providedIn: 'root'
})
export class SignalMessageService {  
  
  constructor(private http: HttpClient, private occService:OccEndpointsService) { }

  getSignalMsg(countryIsoCode) {
    return this.http.get(this.occService.buildUrl(`kbsignalmessage/getsignalmessage?countryIsoCode=${countryIsoCode}`))
  }
}